/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  actionLabel: {
    id: 'App.InitializeApplicableFractionsAction.actionLabel',
    defaultMessage: 'Calculate Applicable Fractions',
  },
  actionTooltip: {
    id: 'App.InitializeApplicableFractionsAction.actionTooltip',
    defaultMessage:
      'One-time setup action. Run it once property onboarding is complete.',
  },
  fractionsNotConfiguredTooltip: {
    id: 'App.InitializeApplicableFractionsAction.fractionsNotConfiguredTooltip',
    defaultMessage:
      'Every building must have an applicable fraction set before calculations can be initialized.',
  },
  title: {
    id: 'App.InitializeApplicableFractionsAction.title',
    defaultMessage: 'Initialize Applicable Fraction Calculations?',
  },
  onceOnly: {
    id: 'App.InitializeApplicableFractionsAction.onceOnly',
    defaultMessage: 'This action can only be performed once.',
  },
  readyToContinue: {
    id: 'App.InitializeApplicableFractionsAction.readyToContinue',
    defaultMessage: "Are you sure you're ready to continue?",
  },
  noLongerAvailable: {
    id: 'App.InitializeApplicableFractionsAction.noLongerAvailable',
    defaultMessage:
      'After the initial calculation completes, this action will no longer be available.',
  },
  futureAutomatic: {
    id: 'App.InitializeApplicableFractionsAction.futureAutomatic',
    defaultMessage:
      'Future applicable fraction calculations will occur automatically whenever certification changes affect NAUR compliance.',
  },
  cancel: {
    id: 'App.InitializeApplicableFractionsAction.cancel',
    defaultMessage: 'Cancel',
  },
  confirm: {
    id: 'App.InitializeApplicableFractionsAction.confirm',
    defaultMessage: 'Confirm',
  },
  confirming: {
    id: 'App.InitializeApplicableFractionsAction.confirming',
    defaultMessage: 'Calculating...',
  },
  blockersHeading: {
    id: 'App.InitializeApplicableFractionsAction.blockersHeading',
    defaultMessage:
      'Must be fixed before running — {count, plural, one {# item} other {# items}}',
  },
  infoHeading: {
    id: 'App.InitializeApplicableFractionsAction.infoHeading',
    defaultMessage:
      'For your information — {count, plural, one {# item} other {# items}}',
  },
  findingLocation: {
    id: 'App.InitializeApplicableFractionsAction.findingLocation',
    defaultMessage: '{buildingName}',
  },
  findingLocationWithUnit: {
    id: 'App.InitializeApplicableFractionsAction.findingLocationWithUnit',
    defaultMessage: '{buildingName} · Unit {unitNumber}',
  },
  checkingPrerequisites: {
    id: 'App.InitializeApplicableFractionsAction.checkingPrerequisites',
    defaultMessage: 'Checking prerequisites...',
  },
  preflightError: {
    id: 'App.InitializeApplicableFractionsAction.preflightError',
    defaultMessage:
      'Prerequisites could not be checked. Close this dialog and try again.',
  },
  alreadyInitialized: {
    id: 'App.InitializeApplicableFractionsAction.alreadyInitialized',
    defaultMessage:
      'Applicable fraction calculations have already been initialized for this property.',
  },
  genericFailure: {
    id: 'App.InitializeApplicableFractionsAction.genericFailure',
    defaultMessage:
      'The calculation could not be completed. Nothing was saved. You can try again.',
  },
  successTitle: {
    id: 'App.InitializeApplicableFractionsAction.successTitle',
    defaultMessage: 'Success',
  },
  successBody: {
    id: 'App.InitializeApplicableFractionsAction.successBody',
    defaultMessage: 'Applicable fraction calculations have been initialized.',
  },
});

export default messages;
